import React from 'react';
import Page from './Page';
import policies from '../policies.json';

export default function PolicyPage({ policy: name }) {
  const policy = policies[name];
  return (
    <Page title={policy.title} header>
      <div className="blog" dangerouslySetInnerHTML={{ __html: policy.html }} />
    </Page>
  );
}
